import { Link } from "react-router-dom";

export default function FeaturedSection() {
  return (
    <section id="featured" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Explore High-Value Spreadsheet Categories
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            Choose from curated product intelligence categories to jumpstart your research.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
          {/* Card 1 - Fashion */}
          <a
            href="#categories"
            className="group relative bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-full h-[140px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Contemporary%20fashion%20clothing%20collection%20with%20dresses%20tops%20and%20trousers%20displayed%20on%20wooden%20hangers%20against%20warm%20cream%20backdrop%2C%20soft%20diffused%20studio%20lighting%2C%20minimalist%20boutique%20aesthetic%2C%20neutral%20beige%20and%20cream%20tones%2C%20professional%20editorial%20product%20photography%20with%20gentle%20organic%20shadows&width=600&height=280&seq=featured-fashion-v2&orientation=landscape"
                alt="Fashion Products Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-1.5">
                <i className="ri-t-shirt-line text-accent-500 text-sm"></i>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">Fashion Products</h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">Clothing, footwear, and accessories trends</p>
            </div>
          </a>

          {/* Card 2 - Shoes */}
          <a
            href="#categories"
            className="group relative bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-full h-[140px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Diverse%20collection%20of%20stylish%20footwear%20including%20sneakers%20casual%20shoes%20and%20athletic%20trainers%20arranged%20on%20clean%20minimalist%20shelf%20with%20warm%20cream%20background%2C%20soft%20diffused%20natural%20lighting%2C%20professional%20product%20photography%20aesthetic%2C%20neutral%20warm%20beige%20and%20cream%20tones%2C%20balanced%20editorial%20composition%20with%20gentle%20shadows&width=600&height=280&seq=featured-shoes-v2&orientation=landscape"
                alt="Shoe Market Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-1.5">
                <i className="ri-footprint-line text-accent-500 text-sm"></i>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">Shoe Market</h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">Footwear demand and profit analysis</p>
            </div>
          </a>

          {/* Card 3 - Electronics */}
          <a
            href="#categories"
            className="group relative bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-full h-[140px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20tech%20gadgets%20headphones%20smartwatches%20and%20portable%20speakers%20displayed%20on%20light%20wooden%20surface%20with%20warm%20cream%20background%2C%20soft%20natural%20studio%20lighting%2C%20minimalist%20product%20aesthetic%2C%20neutral%20warm%20beige%20tones%2C%20professional%20editorial%20photography%20with%20gentle%20diffused%20shadows&width=600&height=280&seq=featured-electronics-v2&orientation=landscape"
                alt="Electronics Product Data"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-1.5">
                <i className="ri-smartphone-line text-accent-500 text-sm"></i>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">Electronics Data</h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">Gadget trends and market intelligence</p>
            </div>
          </a>

          {/* Card 4 - Accessories */}
          <a
            href="#categories"
            className="group relative bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-full h-[140px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20luxury%20accessories%20including%20leather%20wallets%20silk%20scarves%20and%20designer%20sunglasses%20arranged%20beautifully%20on%20soft%20cream%20surface%2C%20warm%20diffused%20studio%20lighting%2C%20minimalist%20refined%20aesthetic%2C%20neutral%20warm%20beige%20and%20cream%20tones%2C%20professional%20editorial%20product%20photography%20with%20sophisticated%20composition%20and%20soft%20shadows&width=600&height=280&seq=featured-accessories-v2&orientation=landscape"
                alt="Accessories and Luxury Items"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-1.5">
                <i className="ri-glasses-line text-accent-500 text-sm"></i>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">Accessories & Luxury</h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">Premium market segment insights</p>
            </div>
          </a>

          {/* Card 5 - Viral */}
          <a
            href="#categories"
            className="group relative bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-full h-[140px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Trending%20popular%20lifestyle%20products%20beauty%20items%20home%20decor%20and%20fashion%20accessories%20displayed%20in%20artistic%20flat%20lay%20on%20clean%20cream%20surface%2C%20soft%20natural%20overhead%20lighting%2C%20modern%20editorial%20aesthetic%20with%20warm%20neutral%20tones%2C%20professional%20product%20photography%20with%20creative%20balanced%20composition%20and%20gentle%20shadows&width=600&height=280&seq=featured-viral-v2&orientation=landscape"
                alt="Trending Viral Products"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-1.5">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">Viral Products</h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">Trending items with high growth</p>
            </div>
          </a>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="inline-block px-8 py-3 rounded-full bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Browse All Spreadsheet Categories <i className="ri-arrow-right-line ml-1 align-middle"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}